import { render, staticRenderFns } from "./StudentAddresses.vue?vue&type=template&id=206969d5&scoped=true&"
import script from "./StudentAddresses.vue?vue&type=script&lang=js&"
export * from "./StudentAddresses.vue?vue&type=script&lang=js&"
import style0 from "./StudentAddresses.vue?vue&type=style&index=0&id=206969d5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206969d5",
  null
  
)

export default component.exports